import { ReactComponent as FlagIcon } from "./svg/bw-flag.svg";
import "../flag-icon.scss";

export const BWFlag = () => {
  return (
    <span className="flag-icon">
      <FlagIcon />
    </span>
  );
};
